module.exports = "/_next/static/3rd.png";